import {EntityService} from "@/model/service/entity-service"
import {News} from "@/model/entity/news/news"

class NewsService extends EntityService<News> implements INewsService {
  constructor() {
    super("news", News)
  }
}

export interface INewsService extends EntityService<News> {
}

const service = new NewsService()

export const newsService = service
